import { useIntl } from "umi";

export const useLocale = (
  value: string,
  vars?: Record<string, string>
): string => {
  const { formatMessage } = useIntl();
  if (vars) return formatMessage({ id: value }, vars);
  return formatMessage({ id: value });
};
